import Vue from 'vue';
import Vuex from 'vuex';
import makeCrudModule from './modules/crud';
import notifications from './modules/notifications';
import addTransferService from '../services/addtransferstorun';
import creditTransferModule from './modules/credittransfer';
import creditTransferRunService from '../services/credittransferpaymentrun';
import partyService from '../services/party';
import security from "./modules/security";
import markrunasprocessed from "./modules/markrunasprocessed";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    notifications,
    addtransferstorun: makeCrudModule({
      service: addTransferService
    }),
    credittransfer: creditTransferModule,
    credittransferpaymentrun: makeCrudModule({
      service: creditTransferRunService
    }),
    party: makeCrudModule({
      service: partyService
    }),
    markrunasprocessed: markrunasprocessed,
    security: security
  },
  strict: process.env.NODE_ENV !== 'production'
});

export default store;
